import panguForm from './panguForm.vue'
export default panguForm
